import Swal from 'sweetalert2';
import imageCompression from 'browser-image-compression';
import JDate from "jalali-date";
var Base64 = {

// private property
  _keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",

// public method for encoding
  encode : function (input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;

    input = Base64._utf8_encode(input);

    while (i < input.length) {

      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);

      enc1 = chr1 >> 2;
      enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
      enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output +
        this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
        this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);

    }

    return output;
  },

// public method for decoding
  decode : function (input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;

    input = input.replace(/[^A-Za-z0-9]/g, "");

    while (i < input.length) {

      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));

      chr1 = (enc1 << 2) | (enc2 >> 4);
      chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      chr3 = ((enc3 & 3) << 6) | enc4;

      output = output + String.fromCharCode(chr1);

      if (enc3 !== 64) {
        output = output + String.fromCharCode(chr2);
      }
      if (enc4 !== 64) {
        output = output + String.fromCharCode(chr3);
      }

    }

    output = Base64._utf8_decode(output);

    return output;

  },

// private method for UTF-8 encoding
  _utf8_encode : function (string) {
    string = string.replace(/\r\n/g,"\n");
    var utftext = "";

    for (var n = 0; n < string.length; n++) {

      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      }
      else if((c > 127) && (c < 2048)) {
        utftext += String.fromCharCode((c >> 6) | 192);
        utftext += String.fromCharCode((c & 63) | 128);
      }
      else {
        utftext += String.fromCharCode((c >> 12) | 224);
        utftext += String.fromCharCode(((c >> 6) & 63) | 128);
        utftext += String.fromCharCode((c & 63) | 128);
      }

    }

    return utftext;
  },

// private method for UTF-8 decoding
  _utf8_decode : function (utftext) {
    var string = "";
    var i = 0;
    var c =0, c3 =0, c2 = 0;

    while ( i < utftext.length ) {

      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      }
      else if((c > 191) && (c < 224)) {
        c2 = utftext.charCodeAt(i+1);
        string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
        i += 2;
      }
      else {
        c2 = utftext.charCodeAt(i+1);
        c3 = utftext.charCodeAt(i+2);
        string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        i += 3;
      }

    }

    return string;
  }

}

export default Base64;

export function encodeParams(params)
{
  return Base64.encode(JSON.stringify(params))
}

export function decodeParams(params)
{
  return JSON.stringify(Base64.decode(params))
}

export function jwtDecrypt(token)
{
  try
  {
    return JSON.parse(atob(token.split('.')[1]))
  }
  catch (e)
  {
    return null;
  }
}

export function getFormData(selector)
{
  const data = new FormData();
  const formData = window.$(selector).serializeArray();
  const n = formData.length;
  for (let i = 0; i < n; i++)
  {
    data.append(formData[i].name, formData[i].value);
  }
  return data;
}

export function showSystemNoti(type, body,func)
{
  if (type === "danger" || type === "error")
    type = "error";
  else if (type !== "warning")
    type = "success";

  if (typeof func === "function")
  {
    Swal.fire({
      title: '',
      html: body,
      type: type,
      icon: type,
      confirmButtonColor: "#2196f3",
      confirmButtonText: "تایید",
      closeOnConfirm: false,
      onAfterClose:func
    });
  }
  else
  {
    Swal.fire({
      title: '',
      html: body,
      type: type,
      icon: type,
      confirmButtonColor: "#2196f3",
      confirmButtonText: "تایید",
      closeOnConfirm: true
    });
  }
}

export function openWebpage(url){
  window.open(url, '_system', 'location=yes'); return false;
}

export function isJson(str)
{
  try
  {
    if (typeof str == "object")
      return true;
    JSON.parse(str);
  } catch (e)
  {
    return false;
  }
  return true;
}

export function fixCardTableSortBtn()
{
  const $ = window.$;
  setTimeout(function (){
    $('.card-table table.table').each(function (){
      const parent = $(this)
      if(parent.find('.sorting_asc').length)
      {
        $(this).find('.sort-btn strong').html(parent.find('.sorting_asc').text());
        parent.find('.sort-btn').removeClass('desc').addClass('asc');
      }
      else
      {
        $(this).find('.sort-btn strong').html(parent.find('.sorting_desc').text());
        parent.find('.sort-btn').removeClass('asc').addClass('desc');
      }
    })
  },700)
}

export function makeCode(len, numeric = false, alpha = false)
{
  let text = "";
  let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  if (numeric)
  {
    possible = "0123456789";
  }
  if (alpha)
  {
    possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  }

  for (let i = 0; i < len; i++)
  {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}


export function dateInput(date,time=false)
{
  let output ='--';
  date = new Date(date);
  const JDate= require('jalali-date');
  try
  {
    const jdate = new JDate(date);
    output = jdate.format('YYYY/MM/DD');
    if (time)
    {
      const gDate = new Date(date);
      let hours = gDate.getHours();
      let minutes = gDate.getMinutes();
      let amPm='AM';
      if (hours > 12)
      {
        amPm='PM';
        hours-=12;
      }
      if (hours === 12)
      {
        amPm='PM';
      }
      if (hours < 10)
        hours='0'+hours;
      if (minutes < 10)
        minutes='0'+minutes;
      output += ' '+hours+':'+minutes+' '+amPm ;
    }
  }
  catch (e)
  {
//
  }
  return output;
}
export function getTableHeaders(table)
{
  const $ = window.$;
  let r = [];
  $(table).find('thead tr th').each(function (){
    r.push($(this).text())
  })
  return r;
}

export async function renderFiles(event, createInput, NAME, uIDInputs)
{

  const files = event.target.files;
  const typeImageAccess = ['image/png', 'image/jpg', 'image/webp', 'image/jpeg', 'image/'];

  const imagesComperessed = [];
  const imagesURL = [];
  const imagesFile = [];
  const docFiles = [];
  const docFilesName = [];
  const inputCreatedRepo = []

  for (const file of files)
  {
    if (typeImageAccess.includes(file.type) && NAME != "documents" && NAME != "file")
    {
      const options = {
        maxSizeMB: .4, // حجم حداکثر فایل فشرده شده (این مقدار را تغییر دهید)
        maxWidthOrHeight: 1920,
      };

      try
      {
        const compressedFile = await imageCompression(file, options)
        //این فایلیه که میفرستیم سمت سرور
        const compressedDataURL = URL.createObjectURL(compressedFile);
        // اینم آدرسیه که میزاریم توی src و نشون کاربر میدیم
        const convertedFile = new File([compressedFile], "compressed-image.jpg", {type: "image/jpeg"});

        imagesFile.push(convertedFile);
        imagesURL.push({src: compressedDataURL , id: uIDInputs});
        imagesComperessed.push(compressedFile);
      }
      catch (error)
      {
        console.error('خطا در فشرده‌سازی تصویر:', error);
      }
    }
    else
    {
      docFiles.push(file);
      docFilesName.push({name: file.name , id: uIDInputs});
    }
  }
  //Render Files

  if (createInput)
  {
    if (imagesFile?.length > 0)
    {
      imagesFile.forEach((image) =>
      {
        if (NAME)
        {
          const container = new DataTransfer();
          container.items.add(image);
          const input = document.createElement("input");
          input.name = NAME
          input.type = "file"
          input.id = NAME
          input.classList.add("d-none");
          if (uIDInputs)
            input.classList.add(uIDInputs)
          input.files = container.files;
          inputCreatedRepo.push(input);
        }
      });
    }
    else if (docFiles?.length > 0)
    {
      docFiles.forEach((doc) =>
      {
        if (NAME)
        {
          const container = new DataTransfer();
          container.items.add(doc);
          const input = document.createElement("input");
          input.name = NAME
          input.type = "file"
          input.classList.add("d-none");
          if (uIDInputs)
            input.classList.add(uIDInputs)
          input.files = container.files;
          inputCreatedRepo.push(input);
        }
      })
    }
  }

  return {
    compressed: imagesComperessed,// فایلی که سمت سرور میفرستیم
    url: imagesURL,// فایلی که نشون کاربر میدیم
    file: imagesFile,
    inputs: inputCreatedRepo,
    docs: docFiles,
    docsName: docFilesName
  };
  //Return Finally Data

}

export async function compressImage(event)
{
  const files = event.target.files;
  for (let i = 0; i < files.length; i++)
  {
    let file = files[i];
    if (file.type.match('image.*'))
    {
        // if (this.results === null)
        //   this.results = [];

          const options = {
            maxSizeMB: 0.2,
            maxWidthOrHeight: 1920,
            useWebWorker: true
          }
          try
          {
            const compressedFile = await imageCompression(file, options);

            const fileType = file.type;
            file=new File([compressedFile], file.name, {type:fileType});

            let container = new DataTransfer();
            container.items.add(file);
            return container.files;
          }
          catch (error)
          {
            console.log('error is :',error);
          }

    }
  }
}

export function printDate(date, time = false, dateType= 0) {
  date = new Date(date);
  let output = "--";
  try {
    let dateFormat = "YYYY/MM/DD";
    if (dateType == 1) dateFormat = "YYYY MMM DD";
    else if (dateType == 2) dateFormat = "DD MMMM";
    else if (dateType == 3) dateFormat = "ddd - DD MMMM YYYY";
    else if (dateType == 4) dateFormat = "DD MMMM YYYY";
    else if (dateType == "just_month") dateFormat = "MMMM";
    else if (dateType == "month&year") dateFormat = "YY MMMM";
    const jdate = new JDate(date);
    output = jdate.format(dateFormat);
    if (time) {
      const gDate = new Date(date);
      let hours = gDate.getHours();
      let minutes = gDate.getMinutes();
      if (hours < 10) hours = "0" + hours;
      if (minutes < 10) minutes = "0" + minutes;
      // output = hours+':'+minutes+' '+output ;
      output = output + " " + hours + ":" + minutes;
      if (dateType === "justTime") output = hours + ":" + minutes;
    }
  } catch (e) {
    /* empty */
  }
  return output;
}
